exports.innerAction = [
    {
        _id: '001',
        name: '系统内置行为',
        action_list: [
            {
                name: '元件操作',
                id: 'inner_001',
                template: 'MetaAction'
            },
            // {
            //     name: '显示',
            //     id: 'inner_002',
            //     template: 'SetActive'
            // },
            {
                name: '移动',
                id: 'inner_003',
                template: 'Move'
            },
            {
                name: '旋转',
                id: 'inner_004',
                template: 'Rotate'
            },
            {
                name: '缩放',
                id: 'inner_005',
                template: 'Scale'
            },
            {
                name: '高亮',
                id: 'inner_006',
                template: 'HighLightOn'
            },
            {
                name: '取消高亮',
                id: 'inner_007',
                template: 'HighLightOff'
            },
            {
                name: '停止播放动画',
                id: 'inner_008',
                template: 'StopPlayAnimation'
            },
            // {
            //     name: '打开图片',
            //     id: 'inner_009',
            //     template: 'OpenImage'
            // },
            // {
            //     name: '播放视频',
            //     id: 'inner_010',
            //     template: 'PlayVideo'
            // },
            // {
            //     name: '播放音频',
            //     id: 'inner_011',
            //     template: 'PlayAudio'
            // },
            {
                name: '打开页面',
                id: 'inner_012',
                template: 'OpenPage'
            },
            {
                name: '关闭页面',
                id: 'inner_013',
                template: 'ClosePage'
            }
        ]
    }
]